import { useEffect, useState } from "react";
import * as ReactDOM from "react-dom";
import { Grid, GridColumn as Column, GridNoRecords } from "@progress/kendo-react-grid";
import { Button } from "@progress/kendo-react-buttons";
import { ActiveCell, SignatureCell, EditCommandCell } from "../GridComponents";
import { CiViewList } from "react-icons/ci";
import EditFixedFeeHeader from "./EditFixedFeeHeader";
import ViewFixedHeader from "./ViewFixedHeader";
import { updateFixedFeeHeader, useFixedFeeHeaders } from "services/fixedfeeService";
import { toast } from "react-toastify";
import { GridLoader } from "components/GridLoader";

const EditCommandCell1 = (props) => {
  let dataItem = props.dataItem;
  if (typeof props.dataItem.allowedApps === "string") {
    const array = props?.dataItem?.allowedApps?.split(",");
    dataItem = { ...props.dataItem, allowedApps: array };
  }
  return <EditCommandCell {...props} dataItem={dataItem} component="ProfitCost" />;
};

const ViewCommandCell = (props) => {
  return (
    <td>
      <Button
        style={{ marginLeft: "10px", backgroundColor: "white" }}
        onClick={() => {
          props.enterViewEdit(props.dataItem);
        }}
      >
        <CiViewList size={25} color={"#241CCA"} />
      </Button>
    </td>
  );
};

const NameHeader = (props) => {
  return (
    <div
      onClick={(e) => {
        // props.onClick(e);
      }}
      style={{ textAlign: "center", marginBottom: "7px" }}
    >
      <span className="">{props.title}</span>
      {props.children}
    </div>
  );
};

const ProfitCostTemplateList = () => {
  const [openForm, setOpenForm] = useState(false);
  const [data, setData] = useState([]);
  const [gridLoading, setGridLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [editItem, setEditItem] = useState({
    ProductID: 1,
  });
  const [viewItem, setViewItem] = useState({
    ProductID: 1,
  });
  const [openViewForm, setOpenViewForm] = useState(false);

  const { data: templatesData } = useFixedFeeHeaders();

  useEffect(() => {
    if (templatesData !== null && templatesData !== undefined) {
      setData(templatesData);
    }
  }, [templatesData]);
  const enterEdit = (item) => {
    setOpenForm(true);
    setEditItem(item);
  };

  const enterViewEdit = (item) => {
    setOpenViewForm(true);
    setViewItem(item);
  };

  const handleSubmit = async (event) => {
    setIsSubmitting(true);
    try {
      let allowedApps = "";
      event.allowedApps.map((item) => {
        if (event.allowedApps.indexOf(item) + 1 === event.allowedApps.length) {
          allowedApps += item;
        } else {
          allowedApps += item + ",";
        }
      });
      let data = {
        name: event.name,
        details: event.details,
        currencyCode: event.currencyCode,
        active: event.active,
        allowedApps: allowedApps,
        type: "Profitcost",
      };
      const res = await updateFixedFeeHeader(event.fixedFeeHeaderID, data);
      if (res.success) {
        toast.success(`Template ${event.name} has been updated`);
        setOpenForm(false);
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  const [dataState, setDataState] = useState({
    take: 10,
    skip: 0,
    total: 20,
  });

  const handleCancelEdit = () => {
    setOpenForm(false);
  };

  const MyEditCommandCell = (props) => (
    <EditCommandCell1 {...props} enterEdit={enterEdit} />
  );

  const MyViewCommandCell = (props) => (
    <ViewCommandCell {...props} enterViewEdit={enterViewEdit} />
  );

  const dataStateChange = (e) => {
    setDataState(e.dataState);
  };

  useEffect(() => {
    setTimeout(() => {
      setGridLoading(false);
    }, 500);
  }, []);

  return (
    <div className="settings-grid h-100">
      <Grid
        {...dataState}
        data={data}
        onDataStateChange={dataStateChange}
        style={{ height: "100%", width: "max-content", maxWidth: "100%" }}
        showLoader={gridLoading}
        loader={
          <div style={{ height: "50px" }}>
            <GridLoader />
          </div>
        }
      >
        <GridNoRecords>
          {gridLoading ? (
            <span></span>
          ) : (
            data && data?.length === 0 && "No records available"
          )}
        </GridNoRecords>
        <Column cell={SignatureCell} title=" " field="name" width="70px" />
        <Column field="name" title="Name" width="150px" />
        <Column field="details" title="Details" width="250px" />
        <Column field="allowedApps" title="Allowed Apps" width="250px" />
        <Column cell={ActiveCell} title="Active" width="80px" />
        <Column
          title="Items"
          cell={MyViewCommandCell}
          width="80px"
          headerCell={NameHeader}
        />
        <Column
          title="Edit"
          cell={MyEditCommandCell}
          width="50px"
        // headerCell={NameHeader}
        />
      </Grid>

      {openForm && (
        <EditFixedFeeHeader
          cancelEdit={handleCancelEdit}
          onSubmit={handleSubmit}
          isSubmitting={isSubmitting}
          item={editItem}
        />
      )}

      {openViewForm && (
        <ViewFixedHeader
          cancelEdit={() => {
            setOpenViewForm(false);
          }}
          item={viewItem}
        />
      )}
    </div>
  );
};

export default ProfitCostTemplateList;
